const trackingId = 'G-YX8XYYP5VL';
function initializeAnalytics() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    if (process.env.NODE_ENV !== 'production') {
        return;
    }
    if (document.querySelector('script[data-gtag-id="' + trackingId + '"]')) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args) {
        window.dataLayer.push(args);
    };
    // Default consent denied until user accepts — required for GA4 in EEA
    window.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        wait_for_update: 500,
    });
    window.gtag('js', new Date());
    window.gtag('config', trackingId, { send_page_view: false });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackingId;
    script.setAttribute('data-gtag-id', trackingId);
    document.head.appendChild(script);
}
export function updateAnalyticsConsent(granted) {
    if (typeof window.gtag !== 'function') {
        return;
    }
    const value = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
        analytics_storage: value,
        ad_storage: value,
    });
}
initializeAnalytics();
